import React from 'react'
import { useParams } from 'react-router-dom'
import { Space } from '@gousto-internal/citrus-react'
import { zendeskAPI } from '../../config/routes'
import { HeroWithBreadcrumbs } from '../../components/HeroWithBreadcrumbs'
import { OtherHelpTopics } from '../../components/OtherHelpTopics'
import { useFetch } from '../../hooks/useFetch'
import { TwoColumns, MainColumn, SecondaryColumn } from '../../layouts/TwoColumns'
import { ArticleContent } from '../../components/ArticleContent'
import { ArticleRelated } from '../../components/ArticleRelated'
import { GetInTouch } from '../../components/GetInTouch'
import { mapBackendCategories, mapBackendSections } from '../../utils'

const Article = () => {
  const { id } = useParams()
  let reducedArticle = null
  let sectionID = null
  let error = false
  let categories = []
  let sections = []
  let categoryId = null
  let sectionId = null

  const { fetchResponse, fetchError, isFetchLoading } = useFetch({ url: zendeskAPI.article(id) })

  if (fetchResponse) {
    const { article } = fetchResponse

    if (
      article
      && article.body
      && article.title
    ) {
      reducedArticle = {
        body: article.body,
        title: article.title,
      }
    } else {
      error = true
    }

    if (article && article.section_id) {
      sectionID = article.section_id
    }

    if (fetchResponse.categories && fetchResponse.sections) {
      categoryId = fetchResponse.categories[0].id.toString()
      sectionId = fetchResponse.sections[0].id.toString()
      categories = mapBackendCategories(fetchResponse.categories)
      sections = mapBackendSections(fetchResponse.sections)
    }
  }

  return (
    <>
      <HeroWithBreadcrumbs
        categories={categories}
        currentCategoryId={categoryId}
        sections={sections}
        currentSectionId={sectionId}
      />
      <TwoColumns>
        <MainColumn>
          <ArticleContent
            isLoading={isFetchLoading}
            article={reducedArticle}
            error={!!fetchError || error}
          />
          {sectionID && (
            <>
              <Space size={14} />
              <ArticleRelated articleID={id} sectionID={sectionID} />
            </>
          )}
        </MainColumn>
        <SecondaryColumn>
          <OtherHelpTopics />
          <Space size={5} />
          <GetInTouch location="article" entityId={id} />
        </SecondaryColumn>
      </TwoColumns>
    </>
  )
}

export { Article }
